var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-date-picker',{attrs:{"value":_vm.value,"placeholder":"ДД.ММ.ГГГГ","format":"DD.MM.YYYY","valueFormat":_vm.$const.shortDateValueFormat,"size":_vm.$attrs.size},on:{"change":function($event){return _vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }